import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_LOCATIONS_REQUEST,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  UPDATE_LOCATION_REQUEST,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_FAILURE,
  ASSIGN_ROLES_LOCATIONS_REQUEST,
  ASSIGN_ROLES_LOCATIONS_SUCCESS,
  ASSIGN_ROLES_LOCATIONS_FAILURE,
} from "../dux/settings";
import { apiAction, API_ERROR, API_SUCCESS } from "../dux/api";
import { apiCallComplete, apiCallStart } from "../dux/apiStatus";
import { openSnackbar } from "../dux/snackbar";
import { logOutUser } from "../dux/login";
import { destroySession } from "../helpers/sessionStorageHelper";
import { showPrompt } from "../dux/prompt";
import { promptCategoryType } from "../helpers/constants";
import {
  getAllUsersUrl,
  searchUsersUrl,
  getAllLocationsUrl,
  createUserUrl,
  updateUserUrl,
  deleteUserUrl,
  updateLocationUrl,
  assignRolesLocationsUrl,
  getAdminEmailsUrl,
  getAdminPhoneNumbersUrl,
} from "../helpers/apiEndPoints";

const settingsMiddleware = (store) => (next) => (action) => {
  const { dispatch } = store;

  switch (action.type) {
    // Notification settings fetch via apiMiddleware
    case "FETCH_ADMIN_EMAILS": {
      const state = store.getState();
      const selectedLocation =
        action.payload?.location ||
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        "";
      if (!selectedLocation) {
        store.dispatch(
          openSnackbar({
            message: "Please select a location first.",
            type: "error",
          })
        );
        break;
      }
      next(
        apiAction({
          url: getAdminEmailsUrl(selectedLocation),
          feature: "FETCH_ADMIN_EMAILS",
          method: "GET",
          meta: {
            onSuccess: (data) => {
              store.dispatch({
                type: "SET_ADMIN_EMAILS",
                payload: data.admin_emails || [],
              });
            },
          },
        })
      );
      break;
    }

    case "FETCH_ADMIN_PHONES": {
      const state = store.getState();
      const selectedLocation =
        action.payload?.location ||
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        "";
      if (!selectedLocation) {
        store.dispatch(
          openSnackbar({
            message: "Please select a location first.",
            type: "error",
          })
        );
        break;
      }
      next(
        apiAction({
          url: getAdminPhoneNumbersUrl(selectedLocation),
          feature: "FETCH_ADMIN_PHONES",
          method: "GET",
          meta: {
            onSuccess: (data) => {
              store.dispatch({
                type: "SET_ADMIN_PHONES",
                payload: data.admin_phone_numbers || [],
              });
            },
          },
        })
      );
      break;
    }

    case "ADD_ADMIN_EMAIL": {
      const state = store.getState();
      const selectedLocation =
        action.payload?.location ||
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        "";
      if (!selectedLocation) {
        store.dispatch(
          openSnackbar({
            message: "Please select a location first.",
            type: "error",
          })
        );
        break;
      }
      next(
        apiAction({
          url: getAdminEmailsUrl(selectedLocation),
          feature: "ADD_ADMIN_EMAIL",
          method: "POST",
          data: { email: action.payload.email },
          meta: { location: selectedLocation },
        })
      );
      break;
    }

    // After adding an admin email, fetch the latest list
    case `ADD_ADMIN_EMAIL ${API_SUCCESS}`: {
      const state = store.getState();
      const selectedLocation =
        action.meta?.location ||
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        "";
      if (selectedLocation) {
        store.dispatch({
          type: "FETCH_ADMIN_EMAILS",
          payload: { location: selectedLocation },
        });
      }
      break;
    }

    case "REMOVE_ADMIN_EMAIL": {
      const state = store.getState();
      const selectedLocation =
        action.payload?.location ||
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        "";
      if (!selectedLocation) {
        store.dispatch(
          openSnackbar({
            message: "Please select a location first.",
            type: "error",
          })
        );
        break;
      }
      next(
        apiAction({
          url: getAdminEmailsUrl(selectedLocation),
          feature: "REMOVE_ADMIN_EMAIL",
          method: "DELETE",
          data: { email: action.payload.email },
        })
      );
      break;
    }

    // After removing an admin email, fetch the latest list
    case `REMOVE_ADMIN_EMAIL ${API_SUCCESS}`: {
      const state = store.getState();
      const selectedLocation =
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        action.meta?.location ||
        "";
      if (selectedLocation) {
        store.dispatch({
          type: "FETCH_ADMIN_EMAILS",
          payload: { location: selectedLocation },
        });
      }
      break;
    }

    case "ADD_ADMIN_PHONE": {
      const state = store.getState();
      const selectedLocation =
        action.payload?.location ||
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        "";
      if (!selectedLocation) {
        store.dispatch(
          openSnackbar({
            message: "Please select a location first.",
            type: "error",
          })
        );
        break;
      }
      next(
        apiAction({
          url: getAdminPhoneNumbersUrl(selectedLocation),
          feature: "ADD_ADMIN_PHONE",
          method: "POST",
          data: { phone_number: action.payload.phone_number },
          meta: { location: selectedLocation },
        })
      );
      break;
    }

    // After adding an admin phone, fetch the latest list
    case `ADD_ADMIN_PHONE ${API_SUCCESS}`: {
      const state = store.getState();
      const selectedLocation =
        action.meta?.location ||
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        "";
      if (selectedLocation) {
        store.dispatch({
          type: "FETCH_ADMIN_PHONES",
          payload: { location: selectedLocation },
        });
      }
      break;
    }

    case "REMOVE_ADMIN_PHONE": {
      const state = store.getState();
      const selectedLocation =
        action.payload?.location ||
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        "";
      if (!selectedLocation) {
        store.dispatch(
          openSnackbar({
            message: "Please select a location first.",
            type: "error",
          })
        );
        break;
      }
      next(
        apiAction({
          url: getAdminPhoneNumbersUrl(selectedLocation),
          feature: "REMOVE_ADMIN_PHONE",
          method: "DELETE",
          data: { phone_number: action.payload.phone_number },
        })
      );
      break;
    }

    // After removing an admin phone, fetch the latest list
    case `REMOVE_ADMIN_PHONE ${API_SUCCESS}`: {
      const state = store.getState();
      const selectedLocation =
        state?.settings?.selectedLocation ||
        state?.bookingSetting?.location ||
        action.meta?.location ||
        "";
      if (selectedLocation) {
        store.dispatch({
          type: "FETCH_ADMIN_PHONES",
          payload: { location: selectedLocation },
        });
      }
      break;
    }
    case FETCH_USERS_REQUEST:
      dispatch(apiCallStart({ api: "fetchUsers" }));

      // Build URL based on presence of trimmed search term
      const term = (action.payload?.search_term || "").toString().trim();
      const usersUrl =
        term.length === 0
          ? getAllUsersUrl()
          : `${searchUsersUrl()}?search_term=${encodeURIComponent(term)}`;

      dispatch(
        apiAction({
          url: usersUrl,
          feature: FETCH_USERS_REQUEST,
          method: "GET",
          meta: action.meta,
        })
      );
      break;

    case FETCH_LOCATIONS_REQUEST:
      dispatch(apiCallStart({ api: "fetchLocations" }));
      dispatch(
        apiAction({
          url: getAllLocationsUrl(),
          feature: FETCH_LOCATIONS_REQUEST,
          method: "GET",
        })
      );
      break;

    case CREATE_USER_REQUEST:
      dispatch(apiCallStart({ api: "createUser" }));
      dispatch(
        apiAction({
          url: createUserUrl(),
          feature: CREATE_USER_REQUEST,
          method: "POST",
          data: action.payload,
        })
      );
      break;

    case UPDATE_USER_REQUEST:
      dispatch(apiCallStart({ api: "updateUser" }));
      dispatch(
        apiAction({
          url: updateUserUrl(action.payload.id),
          feature: UPDATE_USER_REQUEST,
          method: "PUT",
          data: action.payload,
        })
      );
      break;

    case DELETE_USER_REQUEST:
      dispatch(apiCallStart({ api: "deleteUser" }));
      dispatch(
        apiAction({
          url: deleteUserUrl(action.payload),
          feature: DELETE_USER_REQUEST,
          method: "DELETE",
        })
      );
      break;

    case UPDATE_LOCATION_REQUEST:
      dispatch(apiCallStart({ api: "updateLocation" }));
      dispatch(
        apiAction({
          url: updateLocationUrl(action.payload.id),
          feature: UPDATE_LOCATION_REQUEST,
          method: "PUT",
          data: action.payload,
        })
      );
      break;

    case ASSIGN_ROLES_LOCATIONS_REQUEST:
      dispatch(apiCallStart({ api: "assignRolesLocations" }));
      dispatch(
        apiAction({
          url: assignRolesLocationsUrl(),
          feature: ASSIGN_ROLES_LOCATIONS_REQUEST,
          method: "POST",
          data: {
            mobile_number: action.payload.mobile_number,
            roles: action.payload.roles,
            locations: action.payload.locations,
            is_active: action.payload.is_active,
          },
        })
      );
      break;

    // Handle API Success responses
    case `${FETCH_USERS_REQUEST} ${API_SUCCESS}`:
      dispatch(apiCallComplete({ api: "fetchUsers" }));
      // Extract the users array from the response
      // Backend returns: { users: [...], total: number }
      // Frontend expects: users array directly

      // Check if this is a search response or all users response
      let users = [];
      if (action.payload?.users) {
        // Standard response format: { users: [...], total: number }
        users = action.payload.users;
      } else if (Array.isArray(action.payload)) {
        // Direct array response
        users = action.payload;
      } else {
        // Fallback: try to find users in the response
        users = action.payload?.data || action.payload?.results || [];
      }

      dispatch({ type: FETCH_USERS_SUCCESS, payload: users });
      // Optionally update session with fresh current user
      try {
        if (action.meta?.afterSuccessUpdateSession && action.meta?.userId) {
          const me = Array.isArray(users)
            ? users.find((u) => u?.id === action.meta.userId)
            : null;
          if (me) {
            const session = JSON.parse(localStorage.getItem("session") || "{}");
            const newSession = {
              ...session,
              userData: { ...(session.userData || {}), user: me },
            };
            localStorage.setItem("session", JSON.stringify(newSession));
          }
        }
      } catch (_) {}
      break;

    case `${FETCH_LOCATIONS_REQUEST} ${API_SUCCESS}`:
      dispatch(apiCallComplete({ api: "fetchLocations" }));
      // Extract the locations array from the response
      // Backend returns: { locations: [...], total: number }
      // Frontend expects: locations array directly
      const locations = action.payload?.locations || [];
      dispatch({ type: FETCH_LOCATIONS_SUCCESS, payload: locations });
      break;

    case `${CREATE_USER_REQUEST} ${API_SUCCESS}`:
      dispatch(apiCallComplete({ api: "createUser" }));
      dispatch({ type: CREATE_USER_SUCCESS, payload: action.payload });
      dispatch(openSnackbar({ message: "User created successfully" }));
      // Refresh users list to show updated data
      dispatch({ type: FETCH_USERS_REQUEST });
      break;

    case `${UPDATE_USER_REQUEST} ${API_SUCCESS}`:
      dispatch(apiCallComplete({ api: "updateUser" }));
      dispatch({ type: UPDATE_USER_SUCCESS, payload: action.payload });
      dispatch(openSnackbar({ message: "User updated successfully" }));
      // Refresh users list to show updated data
      dispatch({ type: FETCH_USERS_REQUEST });
      break;

    case `${DELETE_USER_REQUEST} ${API_SUCCESS}`:
      dispatch(apiCallComplete({ api: "deleteUser" }));
      dispatch({ type: DELETE_USER_SUCCESS, payload: action.payload });
      dispatch(openSnackbar({ message: "User deleted successfully" }));
      // Refresh users list to show updated data
      dispatch({ type: FETCH_USERS_REQUEST });
      break;

    case `${UPDATE_LOCATION_REQUEST} ${API_SUCCESS}`:
      dispatch(apiCallComplete({ api: "updateLocation" }));
      dispatch({ type: UPDATE_LOCATION_SUCCESS, payload: action.payload });
      dispatch(openSnackbar({ message: "Location updated successfully" }));
      break;

    case `${ASSIGN_ROLES_LOCATIONS_REQUEST} ${API_SUCCESS}`:
      dispatch(apiCallComplete({ api: "assignRolesLocations" }));

      dispatch({
        type: ASSIGN_ROLES_LOCATIONS_SUCCESS,
        payload: action.payload,
      });
      dispatch(
        openSnackbar({ message: "Roles and locations assigned successfully" })
      );
      // Refresh users list using the last_search_term/ui_search_term from state
      try {
        const state = store.getState();
        const raw = (
          state?.settings?.ui_search_term ||
          state?.settings?.last_search_term ||
          ""
        ).toString();
        const term = raw.trim();
        dispatch({ type: FETCH_USERS_REQUEST, payload: { search_term: term } });
      } catch (_) {}
      // Also refresh the current session user using the existing FETCH_USERS_REQUEST flow
      try {
        const state = store.getState();
        const currentUserId = state?.login?.userData?.user?.id;
        if (currentUserId) {
          dispatch({
            type: FETCH_USERS_REQUEST,
            payload: { search_term: currentUserId },
            meta: { afterSuccessUpdateSession: true, userId: currentUserId },
          });
        }
      } catch (_) {}
      break;

    // Handle API Error responses
    case `${FETCH_USERS_REQUEST} ${API_ERROR}`:
      dispatch(apiCallComplete({ api: "fetchUsers" }));
      dispatch({
        type: FETCH_USERS_FAILURE,
        payload:
          action.payload?.data?.response?.message || "Failed to fetch users",
      });
      break;

    case `${FETCH_LOCATIONS_REQUEST} ${API_ERROR}`:
      dispatch(apiCallComplete({ api: "fetchLocations" }));
      dispatch({
        type: FETCH_LOCATIONS_FAILURE,
        payload:
          action.payload?.data?.response?.message ||
          "Failed to fetch locations",
      });
      break;

    case `${CREATE_USER_REQUEST} ${API_ERROR}`:
      dispatch(apiCallComplete({ api: "createUser" }));
      dispatch({
        type: CREATE_USER_FAILURE,
        payload:
          action.payload?.data?.response?.message || "Failed to create user",
      });
      break;

    case `${UPDATE_USER_REQUEST} ${API_ERROR}`:
      dispatch(apiCallComplete({ api: "updateUser" }));
      dispatch({
        type: UPDATE_USER_FAILURE,
        payload:
          action.payload?.data?.response?.message || "Failed to update user",
      });
      break;

    case `${DELETE_USER_REQUEST} ${API_ERROR}`:
      dispatch(apiCallComplete({ api: "deleteUser" }));
      dispatch({
        type: DELETE_USER_FAILURE,
        payload:
          action.payload?.data?.response?.message || "Failed to delete user",
      });
      break;

    case `${UPDATE_LOCATION_REQUEST} ${API_ERROR}`:
      dispatch(apiCallComplete({ api: "updateLocation" }));
      dispatch({
        type: UPDATE_LOCATION_FAILURE,
        payload:
          action.payload?.data?.response?.message ||
          "Failed to update location",
      });
      break;

    case `${ASSIGN_ROLES_LOCATIONS_REQUEST} ${API_ERROR}`:
      dispatch(apiCallComplete({ api: "assignRolesLocations" }));
      dispatch({
        type: ASSIGN_ROLES_LOCATIONS_FAILURE,
        payload:
          action.payload?.data?.response?.message ||
          "Failed to assign roles and locations",
      });
      break;

    default:
      break;
  }

  return next(action);
};

export default settingsMiddleware;
